export default {
  superUserFaqs(state) {
    return state.superUserFaqs;
  },
  superUserFaqTypes(state) {
    return state.superUserFaqTypes;
  },
  superUserFaqTypesForSelect(state) {
    return state.superUserFaqTypes.map((type) => ({
      id: type.value,
      text: type.name,
    }));
  },
};
